import request from '@/utils/request'

export function listScheduleVisitEvents(params) {
  return request({
    url: '/api/schedule/visit-events',
    method: 'get',
    params
  })
}
